import { HttpRequest, HttpResponse, HttpInterceptor, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

abstract class HttpCache {
    abstract get(req: HttpRequest<any>): HttpResponse<any>|null;
    abstract put(req: HttpRequest<any>, resp: HttpResponse<any>): void;
}

@Injectable()
export class HttpCacheService implements HttpCache {
    cache = {};
    put(req: any, resp: any): void {
        // console.log(String(req));
        // console.log(typeof resp);
        this.cache[String(req)] = resp;
        // console.log(this.cache);
    }
    get(req: any): any {

        // console.log(this.cache);
        return this.cache[String(req)];
    }
}
